import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

// Async thunk for fetching video categories
export const fetchVideoCategories = createAsyncThunk(
  'videos/fetchVideoCategories',
  async ({ page = 1 }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_BASE_URL}/customer/video-categories?minimal=1&page=${page}`
      );
      return response.data.data;  // Return categories data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for fetching get-started videos
export const fetchGetStartedVideos = createAsyncThunk(
  'videos/fetchGetStartedVideos',
  async ({ page = 1, category = 1 }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/customer/get-started-videos?page=${page}&category=${category}`
      );
      return response.data.data;  // Return videos data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const getStartedVideosSlice = createSlice({
  name: 'customer_videos',
  initialState: {
    videos: [],
    categories: [],
    currentPage: 1,
    totalPages: 1,
    loading: false,
    errorMessage: '',
  },
  reducers: {
    clearMessage: (state, action) => {
      state.errorMessage = '';
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle video categories
      .addCase(fetchVideoCategories.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
      })
      .addCase(fetchVideoCategories.fulfilled, (state, action) => {
        state.categories = action.payload;
        state.loading = false;
      })
      .addCase(fetchVideoCategories.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload ? action.payload.message : action.error.message;
      })
      
      // Handle get started videos
      .addCase(fetchGetStartedVideos.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
      })
      .addCase(fetchGetStartedVideos.fulfilled, (state, action) => {
        state.videos = action.payload.data;
        state.currentPage = action.payload.current_page;
        state.totalPages = action.payload.last_page;
        state.loading = false;
      })
      .addCase(fetchGetStartedVideos.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload ? action.payload.message : action.error.message;
      });
  },
});

export const { clearMessage } = getStartedVideosSlice.actions;

export default getStartedVideosSlice.reducer;
